<template>
    <v-dialog @keydown.left="goLeft"  @keydown.right="goRight" @keydown.esc="hide"  v-model="show" loading fullscreen hide-overlay transition="dialog-bottom-transition" style="overflow:hidden !important;">
        <video id="video_flare2"  muted="" loop autoplay class="fullscreen-bg__video" style="">
            <source :src="require('../assets/white_flare.webm')" type="video/webm">

        </video>
        <v-card v-if="show" dark style="background:rgba(0,0,0,0.9)" >
            <v-toolbar   style="cursor:pointer;z-index: 1;position:relative;background: transparent;" dark >
                <v-btn icon dark @click="hide">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="this.$vuetify.breakpoint.mdAndUp">Samling</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn style="margin-left: -150px;" v-if="this.$vuetify.breakpoint.mdAndUp && show_arrows" icon dark @click="goLeft">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-toolbar-items style="width: 400px;">
                    <v-list-item>
                        <v-list-item-avatar >
                            <v-img
                                    :src="'/api/images/cards/streamer_images/'+card_data.STID+'/avatar.png'"
                            ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">{{card_data.NAME}}</v-list-item-title>
                            <v-list-item-subtitle>med {{card_data.USER_NAME}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>

                        <v-btn style=""  small class="mx-auto" :class="rank_color">
                            {{rank_text}}
                        </v-btn>
                    </v-list-item>

                </v-toolbar-items>
                <v-btn  v-if="this.$vuetify.breakpoint.mdAndUp && show_arrows" icon dark @click="goRight">
                    <v-icon>mdi-arrow-right</v-icon>
                </v-btn>

                <v-spacer></v-spacer>


                <v-progress-linear
                        v-if="loading"
                        style="position:absolute;bottom:0;left:0;"
                        color="teal"
                        height="10"
                        value="100"
                        striped
                        indeterminate
                ></v-progress-linear>

            </v-toolbar>









            <v-card-text>

            </v-card-text>
        </v-card>

        <div ref="renderContainer" style="z-index:0;top:0;position:absolute;width:100%;height:100%;">
            <canvas :class="faded" ref="renderCanvas"></canvas>
        </div>
        <canvas style="display:none;visibility:hidden;" id="normalMapper" height="890" width="640"></canvas>

        <v-navigation-drawer
                absolute
                permanent
                class="transparent"
                right
                dark
                clipped
                floating
                width="400"
                v-if="$vuetify.breakpoint.mdAndUp && show"
        >
            <v-container fill-height fluid>
                <v-row align="center"
                       justify="center">
                    <v-col>
                        <v-card
                                class="transparent"
                                flat
                                max-width="400"

                        >
                            <v-img
                                    :src="'/api/images/cards/collections/'+card_data.COID+'/render.png'"
                                    height="194"

                            >

                                <v-chip style="position:absolute;top:0px;left:0;"
                                        v-if="collection!==''"
                                        class="ma-2"
                                        label
                                >
                                    {{collection}}
                                </v-chip>



                            </v-img>

                            <v-card-text>
                                <v-sheet
                                        :elevation=10
                                        color="grey darken-3"
                                        class="pa-2"
                                >
                                    <div class="ma-2">{{card_data.DESC}}</div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-progress-linear
                                                    v-on="on"
                                                    :value="float*100"
                                                    color="#4e0d0d"
                                                    height="25"
                                                    background-color="black"
                                                    dark

                                            >
                                                <template >
                                                    <span >{{ float.toFixed(2)}}</span>
                                                </template>
                                            </v-progress-linear>
                                        </template>
                                        <span>Float</span>
                                    </v-tooltip>

                                </v-sheet>



                            </v-card-text>

                            <v-card-actions v-if="card_data.TYPE!=='TEST'">
                                <v-btn
                                        text
                                        @click="showMore = !showMore"

                                >
                                    <v-icon left>{{ showMore ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>{{ showMore ? 'mindre' : 'mer' }}
                                </v-btn>
                                <v-spacer></v-spacer>

                            </v-card-actions>
                            <v-expand-transition v-if="card_data.TYPE!=='TEST'">
                                <div v-show="showMore">
                                    <v-divider></v-divider>

                                    <v-card-text>

                                        <v-list-item two-line>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>Datum Öppnad</v-list-item-subtitle>
                                                <v-list-item class="pl-0">
                                                    {{card_data.DATE_REG}}

                                                </v-list-item>
                                            </v-list-item-content>
                                        </v-list-item>


                                        <v-list-item v-if="byModel!==-1" three-line>
                                            <v-list-item-content>
                                                <v-list-item-subtitle>Sällsynthet</v-list-item-subtitle>
                                                <v-list-item class="pl-0">
                                                    Det finns {{byModel-1}} till {{card_data.NAME}}-kort.
                                                </v-list-item>
                                                <v-list-item class="pl-0">
                                                    Det finns {{byRank-1}} till {{card_data.NAME}}-kort med denna dekor.
                                                </v-list-item>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-card-text>
                                </div>
                            </v-expand-transition>
                        </v-card>
                        <v-row v-if="isMine && !showoff">
                            <v-col></v-col>
                            <v-col>
                                <v-btn v-if="!isUsing" @click="flex" text><v-icon>send</v-icon> Flexa</v-btn>
                                <v-btn loading v-else><v-icon>send</v-icon>Flexar</v-btn>



                            </v-col>
                            <v-col>

                            </v-col>

                        </v-row>
                        <v-row v-if="showoff">
                            <v-col></v-col>
                            <v-col>
                                <v-btn  disabled text><v-icon>send</v-icon> Flexa</v-btn>



                            </v-col>
                            <v-col>

                            </v-col>

                        </v-row>
                    </v-col>
                </v-row>
            </v-container>





        </v-navigation-drawer>

        <v-row style="position:absolute;bottom:0;" v-if="card_data!==null && this.$vuetify.breakpoint.smAndDown">
            <v-col></v-col>
            <v-col>
                <v-card
                        max-width="400"
                        class="mx-auto"
                        dark
                >   <v-expand-transition>
                    <div v-show="mobileShow">
                        <v-divider></v-divider>

                        <v-card-text>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-subtitle>Kollektion</v-list-item-subtitle>
                                    <v-list-item class="pl-0">
                                        {{collection}}

                                    </v-list-item>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content>
                                    <v-list-item-subtitle>Datum Öppnad</v-list-item-subtitle>
                                    <v-list-item class="pl-0">
                                        {{card_data.DATE_REG}}

                                    </v-list-item>
                                </v-list-item-content>
                            </v-list-item>


                            <v-list-item v-if="byModel!==-1" three-line>
                                <v-list-item-content>
                                    <v-list-item-subtitle>Sällsynthet</v-list-item-subtitle>
                                    <v-list-item class="pl-0">
                                        Det finns {{byModel-1}} till {{card_data.NAME}}-kort.
                                    </v-list-item>
                                    <v-list-item class="pl-0">
                                        Det finns {{byRank-1}} till {{card_data.NAME}}-kort med denna dekor.
                                    </v-list-item>
                                </v-list-item-content>
                            </v-list-item>
                            <v-sheet
                                    :elevation=10
                                    color="grey darken-3"
                                    class="pa-2"
                            >
                                <div class="ma-2">{{card_data.DESC}}</div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                                v-on="on"
                                                :value="float*100"
                                                color="#4e0d0d"
                                                height="25"
                                                background-color="black"
                                                dark

                                        >
                                            <template >
                                                <span >{{ float.toFixed(2)}}</span>
                                            </template>
                                        </v-progress-linear>
                                    </template>
                                    <span>Float</span>
                                </v-tooltip>

                            </v-sheet>
                        </v-card-text>
                    </div>
                </v-expand-transition>
                    <v-img
                            :src="'/api/images/cards/collections/'+card_data.COID+'/render.png'"
                            height="100"

                    >

                        <v-chip style="position:absolute;top:0px;left:0;"
                                v-if="collection!==''"
                                class="ma-2"
                                label
                        >
                            {{collection}}
                        </v-chip>
                        <v-btn
                                style="position:absolute;top:0;right:0;"
                                light
                                text
                                @click="mobileShow = !mobileShow"
                        >
                            <v-icon left>{{ mobileShow ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>{{ mobileShow ? 'mindre' : 'mer' }}
                        </v-btn>



                    </v-img>

                <v-card-actions v-if="isMine && !showoff">
                    <v-spacer></v-spacer>
                    <v-btn dark v-if="!isUsing" @click="flex" text><v-icon>send</v-icon> Flexa</v-btn>
                    <v-btn dark loading v-else><v-icon>send</v-icon>Flexar</v-btn>
                </v-card-actions>
                <v-card-actions v-if="showoff">
                    <v-spacer></v-spacer>
                    <v-btn dark text disabled><v-icon>send</v-icon> Flexa</v-btn>
                </v-card-actions>

                </v-card>
            </v-col>
            <v-col></v-col>

        </v-row>


    </v-dialog>
</template>

<script>
    import * as Three from 'three'
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"
    import {CollectionCard3D} from "../helpers/CollectionCard3D"






    export default {
        name: "CollectioncardHolder",
        components: {},
        props:{
            "card_data":Object,
            "show":Boolean,
            "showoff":Boolean,
            "show_arrows":Boolean

        },
        data(){
            return{
                loading:true,
                camera: null,
                scene: null,
                renderer: null,
                mesh: null,
                controls:null,
                card:null,
                camToSave:{},
                model:1,
                collection:"",
                byRank:-1,
                byModel:-1,
                mobileShow:false,
                renderCanvas:null,
                renderContainer:null,
                showMore:true,
                collectioncard3d:null,
                isUsing:false,
                faded:""


            }
        },
        methods: {
            hide:function(){
                this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);

                this.$emit("hide");
            },
            goLeft:function(){
                this.$emit("goLeft");
            },
            goRight:function(){
                this.$emit("goRight");
            },

            init: function() {
                this.renderCanvas= this.$refs.renderCanvas;
                this.renderContainer= this.$refs.renderContainer;

                console.log("IN INIT!");
                this.camera = new Three.PerspectiveCamera(75, this.renderContainer.clientWidth/this.renderContainer.clientHeight, 0.1, 1000);
                this.camera.position.z = 10;


                this.scene = new Three.Scene();

                let light1 = new Three.PointLight( "white", 0.75 );
                let light2 = new Three.PointLight( "white", 0.75 );
                let light3 = new Three.AmbientLight( "white", 0.2 );
                light1.position.set( 0, 5, 50 );
                light2.position.set(0, 5, -50 );

                this.scene.add(light1);
                this.scene.add(light2);
                this.scene.add(light3);

                this.renderer = new Three.WebGLRenderer({canvas:this.renderCanvas,antialias:true,alpha:true,preserveDrawingBuffer: true });
                this.renderer.sortObjects = false;

                this.renderer.setSize(this.renderContainer.clientWidth, this.renderContainer.clientHeight);
                this.controls = new OrbitControls(this.camera, this.renderer.domElement);
                this.controls.enableDamping=true;
                this.controls.maxDistance=10;
                this.controls.minDistance=5;
                this.controls.enablePan=false;
                this.controls.autoRotate=true;
                this.controls.dampingFactor=0.05;
                this.controls.autoRotateSpeed=5;

                this.controls.rotateSpeed=1;

                this.camera.position.z=10;

                this.camera.position.z=10;
                this.camToSave.position = this.camera.position.clone();
                this.camToSave.rotation = this.camera.rotation.clone();
                this.camToSave.controlCenter = this.controls.target.clone();
                //container.appendChild(this.renderer.domElement);
                this.updateCard();
                this.loading=false;


            },

            onResize:function(){
                //let container=document.getElementById('container0');
                console.log("RESIZE");
                if(this.show){
                    this.camera.aspect = this.$refs.renderContainer.clientWidth / this.$refs.renderContainer.clientHeight;
                    this.camera.updateProjectionMatrix();

                    this.$refs.renderCanvas.width=this.$refs.renderContainer.clientWidth;
                    this.$refs.renderCanvas.height=this.$refs.renderContainer.clientHeight;


                    this.renderer.setSize( this.$refs.renderContainer.clientWidth , this.$refs.renderContainer.clientHeight );
                }

            },
            animate: function() {
                requestAnimationFrame(this.animate);
                this.controls.update();
                this.renderer.render(this.scene, this.camera);
            },
            updateCard:function(){
                    this.faded="";
                    this.controls.autoRotateSpeed=5;
                    this.isUsing=false;
                    let cc_p=new CollectionCard3D(this.card_data,this.$store);
                    this.collectioncard3d=cc_p;
                    let cc=cc_p.render();
                    let removeMe = this.scene.getObjectByName("card");
                    if(removeMe!==null){
                        this.scene.remove(removeMe);
                    }
                    cc.name="card";
                    //this.restoreCamera(this.camToSave.position, this.camToSave.rotation, this.camToSave.controlCenter);

                    this.scene.add(cc);
                    if(this.card_data.TYPE!=="TEST"){
                        this.get_card_uq();
                    }
                    else{
                        this.collection="Test"
                    }



            },
            get_card_uq:function(){
                this.collection="";
                this.byRank=-1;
                this.byModel=-1;
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/get_card_uq?CID='+this.card_data.CID;

                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("err")

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText==="no data"){
                            return {"COLLECTION_NAME":"Okänd","BYMODEL":0,"BYRANK":0}
                        }
                        else{
                            let data = JSON.parse(http.response);
                            self.byModel=data[0].BYMODEL;
                            self.byRank=data[0].BYRANK;
                            self.collection=data[0].COLLECTION_NAME



                        }

                    }


                };
                http.send();
            },
            restoreCamera(position, rotation, controlCenter){
                this.camera.position.set(position.x, position.y, position.z);
                this.camera.rotation.set(rotation.x, rotation.y, rotation.z);
                this.controls.target.set(controlCenter.x, controlCenter.y, controlCenter.z);
                this.controls.update();
            },

            animateUse(){
                this.isUsing=true;
                this.collectioncard3d.animateUse();
                let self=this;

                setTimeout(function(){
                    self.faded="fade-out"
                    self.$store.commit("update_snackbar","Flex skickat");

                },3000);
                setTimeout(function(){
                    self.collectioncard3d.removeUse();
                    self.$emit("hide")
                    self.faded="";
                    self.controls.autoRotateSpeed=5;
                    self.isUsing=false;


                },7000);

            },
            flex:function(){

                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/use_collection_card?id='+this.card_data.CID;
                let self=this;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {
                        self.$store.commit("update_snackbar","Streamerns Hicards-widget verkar offline");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let resp=JSON.parse(http.response);

                        if(resp["status"]==="ok"){
                            self.animateUse();


                        }
                        else if(resp["toolow"]){
                            let rank_to_decor={0:"common",1:"rare",2:"epic",3:"legendary"};
                            self.$store.commit("update_snackbar","Streamern kräver "+rank_to_decor[resp["toolow"]]+"-kort för Flex!");


                        }
                        else if(resp["cooldown"]){
                            self.$store.commit("update_snackbar",`Vänta ett tag innan du flexar igen!`);


                        }
                        else{
                            self.$store.commit("update_snackbar","Streamern Hicards-widget verkar offline");


                        }

                    }


                };
                http.send();
            }




        },
        mounted() {
            if(this.card_data!==null && this.show){
                let self=this;

                setTimeout(function(){

                    self.init();
                    self.animate();
                    window.addEventListener('resize', self.onResize)
                },500);
            }
        },
        watch:{
            card_data:function(){
                if(this.card_data!==null && this.show){
                    console.log("UPDATE YO")

                    if(this.scene===null){
                        let self=this;

                        setTimeout(function(){
                            self.init();
                            self.animate();
                            window.addEventListener('resize', self.onResize)
                        },500);


                    }
                    else{
                        let self=this;
                        setTimeout(function(){
                            self.onResize();

                        },500);

                        this.updateCard();

                    }
                }
                else{
                    console.log(this.card_data)
                }
            }
        },
        computed:{
            isMine:function(){
                let id=window.location.pathname.substring(11);

                return id.toString()===this.$store.state.STREAMER.SID.toString();
            },
            rank_color:function(){
                if(this.card_data.RANK_VALUE===0){
                    return "green"
                }
                else if(this.card_data.RANK_VALUE===1){
                    return "blue"
                }
                else if(this.card_data.RANK_VALUE===2){
                    return "purple"
                }
                else if(this.card_data.RANK_VALUE===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.card_data.RANK_VALUE===0){
                    return "Vanlig"
                }
                else if(this.card_data.RANK_VALUE===1){
                    return "Ovanlig"
                }
                else if(this.card_data.RANK_VALUE===2){
                    return "Epic"
                }
                else if(this.card_data.RANK_VALUE===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            },
            float:function(){
                return (Math.sqrt((this.card_data.FLOAT_X*this.card_data.FLOAT_X)+(this.card_data.FLOAT_Y*this.card_data.FLOAT_Y))/Math.sqrt(2));
            }
        }
    }
</script>

<style scoped>
    .fade-out {
        animation: fadeOut ease 5s;
        -webkit-animation: fadeOut ease 5s;
        -moz-animation: fadeOut ease 5s;
        -o-animation: fadeOut ease 5s;
        -ms-animation: fadeOut ease 5s;
    }
    @keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-moz-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-o-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-ms-keyframes fadeOut {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }
</style>
